import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const WarmupToggleWrapper = styled.div`
  display: flex;
`;

export const Label = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: ${darkgrey};
  margin-right: 10px;
  margin-top: 2px;
`;
